import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Error } from "@progress/kendo-react-labels";
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import { Input } from '@progress/kendo-react-inputs';
import { Checkbox } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons';
import { useGlobalState } from '../App.js';
import { Loader } from "@progress/kendo-react-indicators";
import { useMsal } from "@azure/msal-react";
import { loginRequest, protectedResources } from "../authConfig";
import { useTranslation } from "react-i18next";
import useFetchWithMsal from '../hooks/useFetchWithMsal';
import edRights from '../data/edRights.json';
export const SignIn = () => {
    const { instance } = useMsal();
    const navigate = useNavigate(); 
    
    const [loginErr, setLoginErr] = React.useState('');
    const [loginInfo, updateLoginInfo] = useGlobalState();
    const [showLoader, setShowLoader] = React.useState(false);
    const { t } = useTranslation('common');
    
    const { error, execute } = useFetchWithMsal({
        scopes: protectedResources.eyedogzAPI_EDUser.scopes.read,
    });

    const handleSubmit = () => {
        setShowLoader(true);
        setLoginErr('');
        /**
 * When using popup and silent APIs, we recommend setting the redirectUri to a blank page or a page 
 * that does not implement MSAL. Keep in mind that all redirect routes must be registered with the application
 * For more information, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/login-user.md#redirecturi-considerations 
 */
        instance.loginPopup({
            ...loginRequest,
            redirectUri: "/redirect.html", // e.g. /redirect
        }).then((response) => {
            
            console.log('logged in.');
            console.log(JSON.stringify(response));
            console.log('retrieving data');
            // execute("GET", protectedResources.eyedogzAPI_EDUser.endpoint).then((response) => {
            const init = { method: 'GET', headers: { accept: 'application/json', 'Content-Type': 'application/json' } };
            fetch("api/EDUser2", init)
                .then(response => response.json())
                .then((response) => {
                setShowLoader(false);
                console.log("API RESPONSE");
                console.log(JSON.stringify(response));

                if (response.rights.includes(edRights.Login)) {
                    console.log('Has login rights');
                    updateLoginInfo(response);
                    navigate('/home/dashboard');
                }
                else {
                    console.log('No login rights');
                    setLoginErr('No rights to use Eyedogz. Please see administrator');
                }
            });
        }).catch(errorMsg => {
            setShowLoader(false);
            
            setLoginErr('Failed to login:' + errorMsg.errorMessage);
            console.log(JSON.stringify(errorMsg));
            if (error) {
                console.log('API ERROR');
                console.log(error.message)
            }
        });
    }

    const retrieveEyedogzUser = () => { 
        setShowLoader(true);
        // this.setState({ forecasts: data, loading: false });
        const base_url = `controller?username=&password=`;
        const init = { method: 'GET', headers: { accept: 'application/json', 'Content-Type': 'application/json' } };

        fetch(`${base_url}`, init)
            .then(response => response.json())
            .then((response) => {
                if (response.success === true) {
                    console.log('SUCCESS login');
                    setShowLoader(false);
                    //this.setState({
                   //     apiKey: token
                  //  });
                    updateLoginInfo(response);
              //      navigate('/home/dashboard', { state: response });
                    navigate('/home/dashboard');
                }
                else {
                    setShowLoader(false);
                    setLoginErr('Failed to login');
                    console.log('Failed to login');
                }
            });
    }

   return (
      <div className="App">
      <div className="sign-in-page">
 <div className="sign-in-wrapper">
     <div className="logo-wrapper">
         <div className="logo">
             <img src={require('../assets/SmallCovingtonLogoNew.png')} alt={'sign in icon'} /> :
         </div>
         <div className='banner'>
                           {t('SignIn.mainTitle')}
                       </div> 
                      
     </div>
     <div className="inputs-wrapper">
     <Form render={formRenderProps => <FormElement style={{
maxWidth: 650
}}>
                           <div className="col-4"> <div><p>{t('SignIn.instructions')}</p></div></div>
                           <div className="col-4">
     <div className="k-form-buttons">
                               <Link to="" className="dashboard-button" style={{ textDecoration: 'none' }}>
                                   <Button type={'submit'} className="sign-button" onClick={handleSubmit}>
                                       {t('SignIn.buttonTitle')}
                                   </Button>
                               </Link>
                               
                               </div>
                           </div>
                           <div className="col-4">
                               {
                                   showLoader && (
                                       <Loader size="large" />
                                   )
                               }

                           </div>
                           <fieldset className={'k-form-fieldset'}>
                               <Error id={'LGError'}>{loginErr}</Error>
                           </fieldset>
                           
   </FormElement>} />
         
     </div>
    
 </div>
               <div className="frame-wrapper">
                   <div className="second-image-wrapper">
                   <div className="text-wrapper">
                     <h2> {t('SignIn.splashText')}</h2> 
          

         </div>
 </div>
 
</div> 
        
   </div>
 </div>
   )
}